/* global window: true */
import { createStore } from 'redux';
import _ from 'lodash';

const defaultState = {
    slides: [],
    slidesData: {},
    slideInterval: 10,
    currentSlideId: null,
    isEditingWidget: false,
    editingWidget: null,
    inSlideShow: false,
    clientId: null,
    containerWidth: 0,
    rowHeight: 0,
    currentNotification: null,
    companyProfile: {
        colors: {
            mainBg: '#ffffff',
        },
        logo: '',
        darkLogo: '',
    },
    notificationThreshold: 0,
    useCompanyProfile: false,
    isPlaying: false,
    loadingDone: false,
    currencyIso: '',
    licenses: 0,
    showSettingsModal: false,
    showChannelsModal: true,
    openPicker: false,
    customWidgets: [],
};

function counter(state = defaultState, action) {
    switch (action.type) {
    case 'ADD_COMPETITION_CRITERIA': {
        const currentState = Object.assign({}, state);

        currentState.slides.forEach(slide => {
            if (slide.type === 'competition' && !slide.id && action.isNew) {
                slide.competitionSettings.criterias.push({
                    id: action.value,
                    status: 'All',
                    points: 10,
                    type: 'Activity',
                    selectedTypes: ''
                });
            } else if (slide.type === 'competition' && slide.id === action.slideId && !action.isNew) {
                slide.competitionSettings.criterias.push({
                    id: action.value,
                    status: 'All',
                    points: 10,
                    type: 'Activity',
                    selectedTypes: ''
                });
            }
        });

        return currentState;
    }
    case 'DELETE_COMPETITION_CRITERIA': {
        let currentState = Object.assign({}, state);

        currentState.slides.some(slide => {
            if (slide.type === 'competition' && slide.id === action.slideId && !action.isNew) {
                slide.competitionSettings.criterias = action.value;
                return true;
            } else if (slide.type === 'competition' && !slide.id && action.isNew) {
                slide.competitionSettings.criterias = action.value;
                return true;
            }
        });

        return currentState;
    }
    case 'UPDATE_COMPETITION_CRITERIA': {
        const currentState = Object.assign({}, state);
        let criterias;

        //get the competition slide
        currentState.slides.some(slide => {
            if (slide.type === 'competition' && slide.id === action.slideId && !action.isNew) {
                criterias = slide.competitionSettings.criterias;
                return true;
            } else if (slide.type === 'competition' && !slide.id && action.isNew) {
                criterias = slide.competitionSettings.criterias;
                return true;
            }
        });

        //get the matching criteria and update the respective property
        criterias.map((item, itemIndex) => {
            if (itemIndex === action.index) {
                item[action.property] = action.value;
            }
        });

        return currentState;
    }
    case 'SET_NEW_COMPETITION_SLIDE': {
        const currentState = Object.assign({}, state);
        
        currentState.slides.push({
            type: 'competition',
            widgets: [],
            backgroundImage: '',
            custom: {
                bgColor: '',
                bgOpacity: ''
            },
            competitionSettings: {
                name: 'Contest Name',
                goals: 1000,
                criterias: [{
                    id: 0,
                    status: 'All',
                    points: 10,
                    type: 'Activity',
                    selectedTypes: ''
                }]
            }
        });

        return currentState;
    }
    case 'SET_COMPETITION_DATA': {
        const currentState = Object.assign({}, state);
        _.map(currentState.slides, (competitionSlide) => {
            if (competitionSlide.type === 'competition' && competitionSlide.id === action.slideId) {
                competitionSlide.competitionSettings[action.property] = action.value;
            }
        });

        return currentState;
    }
    case 'TOGGLE COLOR PICKER': {
        return Object.assign({}, state, { openPicker: action.open });
    }
    case 'SET SLIDES': {
        const onlyActiveSlides = action.data.filter(slide => slide.inactive !== 1 &&
            (slide.tvIndex || 1) === action.tvIndex);

        const slides = action.data.map(slide => (
            {
                id: slide._id,
                type: slide.type, 
                title: slide.title,
                widgets: slide.widgets,
                inactive: slide.inactive,
                position: slide.position,
                backgroundImage: slide.backgroundImage,
                showCompanyLogo: slide.showCompanyLogo,
                tvIndex: slide.tvIndex,
                custom: slide.custom,
                competitionSettings: slide.competitionSettings,
            }
        ));

        return Object.assign({}, state,
            {
                slides,
                currentSlideId: onlyActiveSlides.length ? onlyActiveSlides[0]._id : null,
                clientId: action.clientId,
                companyProfile: action.companyProfile,
                companyOptions: action.companyOptions,
                slideInterval: action.slideInterval,
                notificationThreshold: action.notificationThreshold,
                useCompanyProfile: action.useCompanyProfile,
                loadingDone: true,
                licenses: action.licenses,
                tvNames: action.tvNames,
                tvIndex: action.tvIndex,
            }
        );
    }
    case 'SET SLIDES DATA':
        return Object.assign({}, state, { slidesData: action.data });

    case 'UPDATE SLIDES2':
        return Object.assign({}, state, { slides: action.data });

    case 'UPDATE SLIDES': {
        const updatedSlides = state.slides.map((slide) => {
            if (slide.id === action.freshSlides._id) {
                return action.freshSlides;
            }

            return slide;
        });

        return Object.assign({}, state, { slides: updatedSlides });
    }
    case 'EDITING WIDGET': {
        return Object.assign({}, state, { isEditingWidget: true,
            editingWidget: action.editingWidget });
    }
    case 'STOP EDITING WIDGET': {
        return Object.assign({}, state, { isEditingWidget: false,
            editingWidget: null });
    }
    case 'REFRESH WIDGETS': {
        const getIndex = _.findIndex(state.slides, ['id', action.id]);

        const arr = [].concat(state.slides);
        arr[getIndex].widgets = action.widgets;

        return Object.assign({}, state, { slides: arr });
    }
    case 'CHANGE CHANNEL': {
        const slide = _.find(state.slides, { tvIndex: action.tvIndex });
        return Object.assign({}, state, {
            tvIndex: action.tvIndex,
            currentSlideId: slide ? slide.id : undefined,
            showChannelsModal: action.showChannelsModal,
        });
    }
    case 'REFRESH SLIDE':
        return Object.assign({}, state, { currentSlideId: action.id });
    case 'SLIDE SAVED': {
        const newArray = state.slides.map((slide) => {
            if (slide.id === action.slide.id) {
                return action.slide;
            }

            return slide;
        });

        return Object.assign({}, state, { slides: newArray });
    }
    case 'CREATE NEW SLIDE':
        return Object.assign({}, state, {
            isEditing: true,
            tvIndex: action.tvIndex,
            showChannelsModal: action.showChannelsModal,
        });
    case 'EDIT SLIDE':
        return Object.assign({}, state, action.states);
    case 'STOP EDIT':
        return Object.assign({}, state, action.states);
    case 'ADD SLIDE': {
        // Moving the id before adding it to the slides array.
        const setId = Object.assign({}, action.data, { id: action.data._id });
        const unsetId = _.omit(setId, '_id');
        
        return Object.assign({}, state, {
            slides: state.slides.concat(unsetId),
            currentSlideId: unsetId.id,
        });
        }
    case 'REMOVE SLIDE': {
        if (action.hasOwnProperty('property') && action.property === 'competition') {
            let filteredSlides = [];
            state.slides.forEach(elem => {
                //slide we want to remove has no id set
                if (elem.id === undefined && elem.type === 'competition') {
                    return;
                }
                filteredSlides.push(elem);
            });
            return Object.assign({}, state, { slides: filteredSlides });
        }

        return Object.assign({}, state,
            { slides: state.slides.filter(elem => elem.id !== action.id) });
        }
    case 'NEXT SLIDE': {
        const onlyActiveSlides = state.slides.filter(slide => slide.inactive !== 1 &&
            slide.tvIndex === state.tvIndex);

        const currentIndex = _.findIndex(onlyActiveSlides, ['id', state.currentSlideId]);

        const nextIndex = currentIndex + 1;

        // Wrap around case.
        if (nextIndex === onlyActiveSlides.length) {
            return Object.assign({}, state, { currentSlideId: onlyActiveSlides[0].id });
        }

        return Object.assign({}, state, { currentSlideId: onlyActiveSlides[nextIndex].id });
    }
    case 'PREVIOUS SLIDE': {
        const onlyActiveSlides = state.slides.filter(slide => slide.inactive !== 1 &&
            slide.tvIndex === state.tvIndex);

        const currentIndexPrev = _.findIndex(onlyActiveSlides, ['id', state.currentSlideId]);

        const previousIndex = currentIndexPrev - 1;

        // Wrap around case.
        if (previousIndex < 0) {
            return Object.assign({}, state,
                { currentSlideId: onlyActiveSlides[onlyActiveSlides.length - 1].id });
        }

        return Object.assign({}, state, { currentSlideId: onlyActiveSlides[previousIndex].id });
    }
    case 'GO TO SLIDE':
        return Object.assign({}, state, { currentSlideId: action.id });
    case 'SET CLIENTID':
        return Object.assign({}, state, { clientId: action.id });
    case 'CALCULATE SIZE':
        return Object.assign({}, state,
            { containerWidth: action.containerWidth, rowHeight: action.rowHeight });
    case 'CURRENT NOTIFICATION':
        return Object.assign({}, state, { currentNotification: action.data });
    case 'DISABLE NOTIFICATION':
        return Object.assign({}, state, { currentNotification: null });
    case 'TOGGLE ISPLAYING':
        return Object.assign({}, state, { isPlaying: !state.isPlaying });
    case 'TOGGLE PROFILE COLORS':
        return Object.assign({}, state, { useCompanyProfile: !state.useCompanyProfile, companyProfile: action.companyProfile });
    case 'WIDGET SAVED': {
        const newArray = state.slides.map((slide) => {
            const newWidget = slide.widgets.map((widget) => {
                if (widget._id === action.widget._id) {
                    return action.widget;
                }

                return widget;
            });

            return Object.assign({}, slide, { widgets: newWidget });
        });

        return Object.assign({}, state, { slides: newArray });
    }
    case 'WIDGET MOVED': {
        const widgetRemovedFromSlides = state.slides.map((slide) => {
            const cleandWidgets = slide.widgets.filter(widget => widget._id !== action.widget._id);

            return Object.assign({}, slide, { widgets: cleandWidgets });
        });

        const widgetInsertedIntoSlide = widgetRemovedFromSlides.map((slide) => {
            if (slide.id === action.slideId) {
                return Object.assign({}, slide, { widgets: slide.widgets.concat(action.widget) });
            }

            return Object.assign({}, slide, { widgets: slide.widgets });
        });

        return Object.assign({}, state, { slides: widgetInsertedIntoSlide });
    }
    case 'WIDGET CREATED': {
        const widgetInserted = state.slides.map((slide) => {
            if (slide.id === action.slideId) {
                return Object.assign({}, slide,
                    { widgets: slide.widgets.concat(action.widget) });
            }

            return Object.assign({}, slide, { widgets: slide.widgets });
        });


        return Object.assign({}, state, { slides: widgetInserted });
    }
    case 'WIDGET REMOVED': {
        const cleanedSlides = state.slides.map((slide) => {
            const cleandWidgets = slide.widgets.filter(widget => widget._id !== action.widgetId);

            return Object.assign({}, slide, { widgets: cleandWidgets });
        });

        return Object.assign({}, state, {
            slides: cleanedSlides,
        });
    }
    case 'ADD WIDGET': {
        let currentState = Object.assign({}, state);
        currentState.slides.some(slide => {
            if (slide.type === 'competition' && !slide.id) {
                slide.widgets = action.widget;
                return true;
            }
        });
        return currentState;
    }
    case 'SET CUSTOM WIDGETS': {
        return Object.assign({}, state, {customWidgets: action.customWidgets})
    }
    case 'SET CURRENCY': {
        return Object.assign({}, state, { currencyIso: action.currency });
    }
    case 'TV NAMES UPDATED': {
        return Object.assign({}, state, { tvNames: action.tvNames });
    }
    case 'UPDATE SLIDE INTERVAL': {
        const companyProfile = state.companyProfile;
        companyProfile.slideInterval = action.slideInterval;
        return Object.assign({}, state, companyProfile);
    }
    case 'UPDATE NOTIFICATION THRESHOLD': {
        const companyProfile = state.companyProfile;
        companyProfile.notificationThreshold = action.notificationThreshold;
        return Object.assign({}, state, companyProfile);
    }
    case 'UPDATE CUSTOMER PROFILE': {
        return Object.assign({}, state, { companyProfile: action.companyProfile });
    }
    case 'TOOGLE SETTINGS MODAL': {
        return Object.assign({}, state, { showSettingsModal: !state.showSettingsModal });
    }
    default:
        return state;
    }
}

export default createStore(counter, window.devToolsExtension && window.devToolsExtension());



/** WEBPACK FOOTER **
 ** ./client/reducers/reducerStore.js
 **/